<div class="wholesaler-pharmacy" *ngIf="userType$ | async as userType">
  <h4 class="color-error" *ngIf="!(defaultSelected$ | async)">
    {{ 'flu.wholesaler-pharmacy.missing-default.' + userType | cxTranslate }}
  </h4>
  <h3 class="mb-3">
    <strong>
      {{ 'flu.wholesaler-pharmacy.popup.' + userType | cxTranslate }}
    </strong>
    <span class="close-icon c-icon-primary" (click)="close()">&times;</span>
  </h3>

  <div class="mb-3">
    <app-wholesaler-search
      *ngIf="userType === userTypes.PHARMACY"></app-wholesaler-search>
    <app-pharmacy-search
      *ngIf="userType === userTypes.NBP"></app-pharmacy-search>
  </div>

  <ng-container *ngIf="{ searchResults: searchResults$ | async } as data">
    <ng-container *ngIf="true">
      <ng-container
        *ngTemplateOutlet="
          withData;
          context: { searchResults: data?.searchResults }
        "></ng-container>
    </ng-container>
    <ng-container *ngIf="data?.searchResults?.length === 0">
      <ng-container *ngTemplateOutlet="empty"></ng-container>
    </ng-container>
    <ng-container *ngIf="!data?.searchResults">
      <ng-container *ngTemplateOutlet="start"></ng-container>
    </ng-container>
    <div class="mt-3 pt-3">
      <div class="currently-selected mb-3" *ngIf="currentlySelected">
        <span class="currently-selected-label">
          {{ 'flu.wholesaler-pharmacy.selected' | cxTranslate }}
        </span>
        <span
          >{{ currentlySelected?.name }} ({{
            (
              currentlySelected.contactAddress ||
              currentlySelected.billingAddress
            )?.town
          }})</span
        >
      </div>
      <button
        class="m-auto c-button c-button--primary"
        [disabled]="!currentlySelected"
        (click)="confirmSelection(userType)">
        {{ 'flu.wholesaler-pharmacy.popup.confirm' | cxTranslate }}
      </button>
    </div>
  </ng-container>

  <ng-template #withData let-searchResults="searchResults">
    <div class="d-flex flex-column container c-radio-container search-results">
      @for (searchResult of searchResults; track searchResult) {
        <div
          class="d-flex gap-1 search-result align-items-center pb-3 mb-3"
          (click)="select(searchResult)">
          <input
            type="radio"
            name="radio"
            [attr.checked]="
              searchResult?.name === currentlySelected?.name || null
            " />
          <div class="c-radio-indicator"></div>
          <div class="d-flex flex-column">
            <span class="font-bold">{{ searchResult.name }}</span>
            <span>{{
              (searchResult.contactAddress || searchResult.billingAddress)
                ?.formattedAddress
            }}</span>
          </div>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #start>
    <div class="w-100 mt-3">
      <p class="text-center">
        {{ 'flu.wholesaler-pharmacy.popup.empty-search' | cxTranslate }}
      </p>
    </div>
  </ng-template>

  <ng-template #empty>
    <div class="w-100 mt-3">
      <p class="text-center">
        {{ 'flu.wholesaler-pharmacy.popup.no-results' | cxTranslate }}
      </p>
    </div>
  </ng-template>
</div>
